import {clearAllBodyScrollLocks, disableBodyScroll} from "body-scroll-lock/lib/bodyScrollLock.es6";

export default class ScrollHandler {
    constructor(backToTopSelector, backToTopOffset) {
        this.backToTopNode = document.querySelector(backToTopSelector);
        this.backToTopOffset = backToTopOffset;

        this.backToTop = this.backToTop.bind(this);

        window.addEventListener('scroll', () => this.trackScroll());
        this.backToTopNode.addEventListener('click', () => this.backToTop());
    }

    backToTop(){
        if (window.pageYOffset > 0) {
            window.scrollBy(0, -50);
            setTimeout(this.backToTop, 0);
        }
    }

    trackScroll() {
        let scrolled = window.pageYOffset;
        let height = document.documentElement.clientHeight;
        let offsetHeight = height + this.backToTopOffset;

        if (scrolled > offsetHeight) {
            this.backToTopNode.classList.add('-show');
        } else {
            this.backToTopNode.classList.remove('-show');
        }
    }

    static disableDocumentScroll(exception){
        disableBodyScroll(exception);
        document.documentElement.style.overflow = 'hidden';
    }

    static enableDocumentScroll(){
        clearAllBodyScrollLocks();
        document.documentElement.style.overflow = '';
    }
}